<template>
	<el-row>
		<el-button size="mini" @click="add">新增+</el-button>
		<el-row :gutter="0">
			<el-col :span="9">
				<div class="search-view">
					<div>优惠券名称:</div>
					<el-input size="mini" v-model="name" class="margin-left-10px"></el-input>
					<el-button type="primary" size="mini" style="margin-left: 10px;" @click="shuaixuan">筛选</el-button>
					<el-button type="infor" size="mini" @click="daochu">导出报表</el-button>
					<el-button type="warning" size="mini" @click="zhikong">置空</el-button>
				</div>
			</el-col>
		</el-row>
		<el-table :data="tableDate">
			<el-table-column label="券id" prop="id"></el-table-column>
			<el-table-column label="券名称" prop="name" width="200px"></el-table-column>
			<el-table-column label="发放数量" prop="publishCount">
				<template slot-scope="scope">
					{{scope.row.publishCount ?scope.row.publishCount:0}}
				</template>
			</el-table-column>
			<el-table-column label="使用数量" prop="useCount"></el-table-column>
			<el-table-column label="面值" prop="amount"></el-table-column>
			<el-table-column label="使用门槛" prop="minPoint">
				<template slot-scope="scope">
					{{scope.row.minPoint == 0 ?'无门槛':scope.row.minPoint}}
				</template>
			</el-table-column>
			<el-table-column label="创建者" prop="crteateUser"></el-table-column>
			<el-table-column label="有效期" prop="expireDays"></el-table-column>
			<el-table-column label="创建时间" prop="created"></el-table-column>
			<el-table-column label="操作" width="200px">
				<template slot-scope="scope">
					<el-button size="mini" type="text" @click="faquan(scope.row)" style="color: #00FF00;">发券</el-button>
					<el-button size="mini" type="text" @click="bianji(scope.row)" style="color: #1CBBB4;">编辑</el-button>
					<el-button size="mini" type="text" @click="chakan(scope.row)" style="color: #0074E6;">查看使用
					</el-button>
					<el-button size="mini" type="text" @click="del(scope.row)" style="color: red;">删除</el-button>
				</template>
			</el-table-column>
		</el-table>

		<el-dialog :title="title" @close="gb" :visible.sync="centerDialogVisible" width="25%" center>
			<el-form :model="info" ref="info" label-position="right" label-width="90px">
				<el-form-item label="券名称:" prop="name" :rules="[{
		                required: true,message: '请输入券名称',trigger: 'change'}]">
					<el-input v-model="info.name" placeholder="30字" maxlength="30" size="mini" show-word-limit>
					</el-input>
				</el-form-item>
				<el-form-item label="面值:" prop="amount" :rules="[{
		                required: true,message: '请输入面值',trigger: 'change'}]">
					<el-input v-model="info.amount" size="mini" type="number" min="0.01" style="width: 100px;">
					</el-input>
				</el-form-item>
				<el-form-item label="使用门槛:" prop="minPoint" :rules="[{
		                required: true,message: '请输入使用门槛',trigger: 'change'}]">
					<el-input v-model="info.minPoint" size="mini" type="number" min="0.01" style="width: 100px;">
					</el-input>
				</el-form-item>
				<el-form-item label="领取后:" prop="perLimit" :rules="[{
		            required: true,message: '请选择领取后',trigger: 'change'}]">
					<el-select v-model="info.expireDays" clearable>
						<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="每人限领:" prop="expireDays" :rules="[{
		            required: true,message: '请输入每人限领次数',trigger: 'change'}]">
					<el-input size="mini" type="number" style="width: 100px;" v-model="info.perLimit" min="0" />张
				</el-form-item>
				<el-form-item label="发放数量:" prop="publishCount" :rules="[{
				    required: true,message: '请输入每人限领次数',trigger: 'change'}]">
					<el-input size="mini" type="number" style="width: 100px;" v-model="info.publishCount" min="0" />张
				</el-form-item>
				<el-form-item>
					<el-button @click="centerDialogVisible = false">取 消</el-button>
					<el-button type="primary" @click="queren()">确 定</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
		<el-dialog :title="title" :visible.sync="centerDialogVisible2" width="25%" center>
			<el-form :model="info2" ref="info2" label-position="right" label-width="90px">
				<el-form-item prop="memberId" :rules="[{
				    required: true,message: '请输入用户id',trigger: 'change'}]" label-width="110px">
					<el-input size="mini" type="number" style="width: 200px;" v-model="info2.memberId" />
				</el-form-item>
				<el-form-item label-width="120px">
					<el-button @click="centerDialogVisible2 = false">取 消</el-button>
					<el-button type="primary" @click="queren2()">确 定</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
		<div style="margin: 20px 30%;">
			<el-pagination class="pagination" background layout="total, sizes,prev, pager, next,jumper"
				:page-size="pageSize" :page-sizes="[30,50,100]" :total="total" :current-page.sync="pageNum"
				@size-change="handleSizeChange" @current-change="handleCurrentChange" />
		</div>
	</el-row>
</template>

<script>
	export default {
		data() {
			return {
				name: "",
				pageNum: 1,
				pageSize: 30,
				total: 0,
				tableDate: [],
				options: [{
						value: 3,
						label: '三天后失效'
					},
					{
						value: 7,
						label: '七天后失效'
					},
					{
						value: 15,
						label: '十五天后失效'
					},
					{
						value: 30,
						label: '三十天后失效'
					}
				],
				title: '',
				centerDialogVisible: false,
				centerDialogVisible2: false,
				info: {
					id: "",
					name: '',
					amount: '',
					minPoint: '',
					perLimit: '',
					expireDays: "",
					publishCount: ''
				},
				info2: {
					couponId: "",
					memberId: "",
				}
			}
		},
		methods: {
			zhikong() {
				this.name = ''
				this.getInfo()
			},
			add() {
				this.centerDialogVisible = true
				this.title = '创建优惠券'
				this.info.name = ""
				this.info.amount = ""
				this.info.minPoint = ""
				this.info.perLimit = ""
				this.info.expireDays = ""
			},
			shuaixuan() {
				this.getInfo()
			},
			daochu() {
				this.$http.post(`/api/course/clrCouponController/exportExcel`, {
					name: this.name
				}, {
					responseType: 'blob'
				}).then(res => {
					console.log(res);
					this.$message({
						type: 'info',
						message: '正在导出优惠券表格'
					});
					const link = document.createElement('a');
					let blob = new Blob([res.data], {
						type: 'application/vnd.ms-excel'
					});
					link.style.display = 'none';
					//设置连接
					link.href = URL.createObjectURL(blob);
					link.download = '优惠券列表';
					document.body.appendChild(link);
					//模拟点击事件
					link.click();
					window.URL.revokeObjectURL(link.href);
					link.remove();
				})
			},
			bianji(row) {
				console.log(row);
				this.centerDialogVisible = true
				this.title = '编辑优惠券'
				this.info.id = row.id
				this.info.name = row.name
				this.info.amount = row.amount
				this.info.minPoint = row.minPoint
				this.info.perLimit = row.perLimit
				this.info.expireDays = row.expireDays
				this.info.publishCount = row.publishCount
			},
			gb() {
				this.getInfo()

			},
			del(row) {
				console.log(row);
				this.$confirm('此操作将永久删除该优惠券, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$http.get(`/api/course/clrCouponController/deleteClrCoupon?id=${row.id}`, {}).then(
						res => {
							if (res.data.status == 0) {
								this.$message({
									type: 'success',
									message: res.data.data
								});
								this.getInfo()
							}
						})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},
			queren() {
				this.$refs.info.validate((valid) => {
					if (valid) {
						if (this.title == "创建优惠券") {
							this.$http.post(`/api/course/clrCouponController/clrCoupon`, {
								name: this.info.name,
								amount: this.info.amount,
								minPoint: this.info.minPoint,
								perLimit: this.info.perLimit,
								expireDays: this.info.expireDays,
								type: 1,
								crteateUser: this.$store.state.userInfo.id,
								publishCount: this.info.publishCount, //发行数量
								surplusCount: this.info.publishCount, //剩余数量,默认等于发行数量
							}).then(res => {
								console.log(res.data);
								if (res.data.status == 0) {
									this.$message.success(res.data.data)
									this.centerDialogVisible = false
								}
							})
						} else if (this.title == "编辑优惠券") {
							this.$http.post(`/api/course/clrCouponController/updateClrCoupon`, {
								id: this.info.id,
								name: this.info.name,
								amount: this.info.amount,
								minPoint: this.info.minPoint,
								perLimit: this.info.perLimit,
								expireDays: this.info.expireDays,
								publishCount: this.info.publishCount,
								surplusCount: this.info.publishCount,
								type: 1,
								crteateUser: this.$store.state.userInfo.id
							}).then(res => {
								if (res.data.status == 0) {
									this.$message.success(res.data.data)
									this.centerDialogVisible = false
								}
							})
						}
					}
				})
			},
			queren2() {
				this.$refs.info2.validate((valid) => {
					if (valid) {
						this.$http.post(`/api/course/clrCouponController/addUserClrCoupon`, {
							couponId: this.info2.couponId, //红包id
							memberId: this.info2.memberId //用户id
						}).then(res => {
							console.log(res.data);
							if (res.data.status == 0) {
								this.$message.success(res.data.msg)
								this.centerDialogVisible2 = false
							} else {
								this.$message.error(res.data.msg)
							}
						})
					}
				})
			},
			faquan(row) {
				console.log(row);
				this.info2.couponId = row.id
				this.centerDialogVisible2 = true
				this.title = "发送" + row.name + "优惠券"
			},
			chakan(row) {
				console.log(row);
				this.$router.push({
					path: './seeUse',
					query: {
						id: row.id,
						name: row.name,
						amount: row.amount,
						minPoint: row.minPoint,
						crteateUser: row.crteateUser,
						expireDays: row.expireDays,
						created: row.created,
					}
				})
			},
			getInfo() {
				this.$http.get(
					`/api/course/clrCouponController/selectList?pageNum=${this.pageNum}&pageSize=${this.pageSize}&name=${this.name}`, {}
				).then(res => {
					console.log(res.data.data.list);
					this.tableDate = res.data.data.list
					this.total = res.data.data.total
				})
			},
			handleSizeChange(val) {
				this.pageNum = 1;
				this.pageSize = val;
				this.getInfo()
			},
			//页数
			handleCurrentChange(val) {
				this.pageNum = val;
				this.getInfo()
			},
		},
		created() {
			this.getInfo()
			console.log(this.$store.state.userInfo.id);
		}
	}
</script>

<style scoped="scoped">

</style>
